"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSupplierCountryListAction = exports.setAllSuppliersAction = exports.setSelectedSupplierAction = void 0;
var databus_1 = require("@portals/databus");
var constants_1 = require("./constants");
var setSelectedSupplierAction = function (selectedSupplier) {
    var _a;
    new databus_1.Databus({ name: constants_1.SELECTED_SUPPLIER }).addEvent({
        detail: {
            selectedSupplier: selectedSupplier,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.SELECTED_SUPPLIER] = selectedSupplier,
            _a),
    });
};
exports.setSelectedSupplierAction = setSelectedSupplierAction;
var setAllSuppliersAction = function (suppliers) {
    var _a;
    new databus_1.Databus({ name: constants_1.SELECTED_SUPPLIER }).addEvent({
        detail: {
            suppliers: suppliers,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.ALL_SUPPLIERS] = suppliers,
            _a),
    });
};
exports.setAllSuppliersAction = setAllSuppliersAction;
var setSupplierCountryListAction = function (countryList) {
    var _a;
    new databus_1.Databus({ name: constants_1.SELECTED_SUPPLIER }).addEvent({
        detail: {
            countryList: countryList,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.SUPPLIER_COUNTRY_LIST] = countryList,
            _a),
    });
};
exports.setSupplierCountryListAction = setSupplierCountryListAction;
